export function clearLocalStorage() {
  localStorage.removeItem("currentUser");
  localStorage.removeItem("token");
  localStorage.removeItem("traingId");
  sessionStorage.removeItem("project");
  sessionStorage.removeItem("training");
}
